import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CButton,
} from 'compat/coreui'
import axios from 'axios';
import Visitors from '../charts/Visitors.js'

const statTile = { padding: '18px 20px', textAlign: 'center' };
const statValue = { fontSize: '200%', fontWeight: 800, display: 'block' };
const statLabel = { fontWeight: 600, opacity: 0.7, fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.05em' };

const Dashboard = () => {
  const history = useNavigate()
  const [analyticsData, setAnalyticsData] = useState([])
  const [totalUsers, setTotalUsers] = useState(0)
  const [totalReviews, setTotalReviews] = useState(0)
  const [totalFollowers, setTotalFollowers] = useState(0)
  const [totalVisitors, setTotalVisitors] = useState(0)
  const [totalPreOrdersPending, setTotalPreOrdersPending] = useState(0)
  const token = localStorage.getItem('token');

  useEffect(() => {
    getAnalyticsData();
  }, [])

  const getAnalyticsData = () => {
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/dashboard`,
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(response => {
      if (response.data.status) {
        setAnalyticsData([...response.data.visitors].sort((a, b) => (a._id > b._id ? 1 : a._id < b._id ? -1 : 0)));
        setTotalVisitors(response.data.visitors.length);
        setTotalUsers(response.data.totalUsers);
        setTotalReviews(response.data.totaReviews);
        setTotalFollowers(response.data.followerCount);
        setTotalPreOrdersPending(response.data.preOrderCount);
      }
    }).catch(() => {})
  }

  const stats = [
    { label: 'Visitors (30d)', value: totalVisitors },
    { label: 'Pending Orders', value: totalPreOrdersPending },
    { label: 'Followers', value: totalFollowers },
    { label: 'Reviews', value: totalReviews },
    { label: 'Platform Users', value: totalUsers },
  ];

  return (
    <>
      <CRow className="mb-4">
        {stats.map(s => (
          <CCol md sm="6" key={s.label} className="mb-3">
            <CCard>
              <CCardBody style={statTile}>
                <span style={statValue}>{s.value ?? 0}</span>
                <span style={statLabel}>{s.label}</span>
              </CCardBody>
            </CCard>
          </CCol>
        ))}
      </CRow>

      <CCard className="mb-4">
        <CCardHeader>Store Traffic</CCardHeader>
        <CCardBody>
          {(analyticsData && analyticsData.length > 0)
            ? <Visitors style={{ height: '300px' }} analyticsData={analyticsData} />
            : <p className="text-muted mb-0">No visitor data yet — traffic will appear here once shoppers view your store.</p>}
        </CCardBody>
      </CCard>

      <CRow className="text-center">
        <CCol sm={12} lg={4} className="mb-3">
          <CCard>
            <CCardHeader>Products</CCardHeader>
            <CCardBody>
              <p>Manage your catalog, prices, and availability.</p>
              <CButton color="success" className="text-white" onClick={() => history('/dashboard/menu-products')}>Manage Products</CButton>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4} className="mb-3">
          <CCard>
            <CCardHeader>Deals</CCardHeader>
            <CCardBody>
              <p>Post specials and deals to attract shoppers.</p>
              <CButton color="success" className="text-white" onClick={() => history('/dashboard/deals')}>Manage Deals</CButton>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4} className="mb-3">
          <CCard>
            <CCardHeader>Orders</CCardHeader>
            <CCardBody>
              <p>Accept, process, and track customer orders.</p>
              <CButton color="success" className="text-white" onClick={() => history('/dashboard/orders')}>View Orders</CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default Dashboard
